module.exports = "<div class=\"card__footer\" fxLayoutAlign=\"center center\">\n  <ng-content></ng-content>\n</div>\n"